import * as React from 'react';
import flatImg from './img/flat.svg';
import newBuildingImg from './img/new-building.svg';
import appartmentImg from './img/appartment.svg';
import townhouseImg from './img/townhouse.svg';

import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { BlockHeader } from '../BlockHeader';
import { LandingBlock } from '../LandingBlock';
import { ContentWrapper } from '../ContentWrapper';

import { trackInterestRateBlock } from './tracking';

import * as style from './styles.css';
import { IMortgageBanksDataRates } from '../../types/redux';
import { InterestRateItem } from './InterestRateItem';

interface IInterestRateProps {
  rates: IMortgageBanksDataRates;
}

export const InterestRate = ({ rates }: IInterestRateProps) => {
  const onElementInViewPort = React.useCallback(() => {
    trackInterestRateBlock();
  }, []);

  return (
    <ElementInViewport onVisibleFirst={onElementInViewPort}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Такие&nbsp;же условия и&nbsp;ставки, как при обращении в&nbsp;банки напрямую</BlockHeader>
          <div className={style['cards']}>
            {rates.used && <InterestRateItem rate={rates.used} imageSrc={flatImg} rateFor="вторичное жилье" />}
            {rates.new && <InterestRateItem rate={rates.new} imageSrc={newBuildingImg} rateFor="новостройки" />}
            {rates.apartments && (
              <InterestRateItem rate={rates.apartments} imageSrc={appartmentImg} rateFor="аппартаменты" />
            )}
            {rates.townhouse && <InterestRateItem rate={rates.townhouse} imageSrc={townhouseImg} rateFor="таунхаусы" />}
          </div>
        </ContentWrapper>
      </LandingBlock>
    </ElementInViewport>
  );
};
